import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Checkbox } from "./Checkbox";

export interface CheckboxGroupOption {
  value: string;
  label: ReactNode;
  icon?: ReactNode;
  endAdornment?: ReactNode;
}

interface CheckboxGroupProps {
  options: CheckboxGroupOption[];
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

export function CheckboxGroup({
  options,
  value,
  onChange,
  className,
}: CheckboxGroupProps) {
  const toggle = (optionValue: string) => {
    onChange(
      value.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...value, optionValue],
    );
  };

  return (
    <div className={twMerge("flex flex-col", className)}>
      {options.map((option) => {
        const checked = value.includes(option.value);
        return (
          <Checkbox
            key={option.value}
            label={
              <div className="flex w-full items-center justify-between gap-2">
                <div className="flex min-w-0 items-center gap-2">
                  {option.icon}
                  <span className="truncate">{option.label}</span>
                </div>
                {option.endAdornment != null && (
                  <span className="shrink-0 text-[11px] font-semibold text-[#98A2B3] group-hover:text-[#1266CC]">
                    {option.endAdornment}
                  </span>
                )}
              </div>
            }
            checked={checked}
            onCheckedChange={() => toggle(option.value)}
            className="rounded-[6px] px-3 py-[7px] hover:bg-[#EBF3FE] hover:text-[#1884F9]"
          />
        );
      })}
    </div>
  );
}
